/**
 * Triangle Sweeper の識別子。
 *
 * **この文字列は5か所で同じ値を指す**（識別子を1つに保つのが方針）:
 *   D1 の `game_key` / `src/games/<ここ>/` / `src/locales/<lang>/<ここ>.json` /
 *   `public/assets/<ここ>/` / localStorage の接頭辞 `<ここ>.*`
 *
 * ※ サーバーの `GAME_KEY_RE = /^[a-z0-9_-]{1,32}$/` を満たす（ハイフン可）。
 *   ここを外すと全 API が 400 になる。
 *
 * ※ Phaser を引かない**軽いモジュール**として独立させてある（二角取りの `gameKey.ts` と同じ理由）。
 */
export const GAME_KEY = 'triangle-sweeper';
